import { Test, TestResult } from "../../types/healthcare/TestTypes";

// The lab's product code for the genetic analysis panel — it lives here and nowhere else.
export const GENETIC_ANALYSIS_TEST_TYPE = "gsa_3";

// Order-level gate: substring match, exactly what both patient-modal call sites have always done.
export const isGeneticAnalysisTest = (test?: Pick<Test, "test_results"> | null): boolean =>
	test?.test_results?.some((r) => r.test_type?.includes(GENETIC_ANALYSIS_TEST_TYPE)) ?? false;

// Single-result gate is an EXACT match — deliberately narrower than the order-level one above.
export const isGeneticAnalysisResult = (result?: Pick<TestResult, "test_type"> | null): boolean =>
	result?.test_type === GENETIC_ANALYSIS_TEST_TYPE;
